import {post} from '../../request'

/**
 * 金额日志
 * @param data
 * @returns {Promise<*>}
 */
export function getAmountList(data) {
    return post("/admin/usermoneylog/index", data)
}

